/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Zero_Fee_TrialInputs */

const en_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try For $0.00`)
};

const ar_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جرب مقابل 0.00 دولار`)
};

const de_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuchen Sie es für $0.00`)
};

const es_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo gratis`)
};

const fr_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayer pour 0,00€`)
};

const it_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova per $0,00`)
};

const ja_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で試す`)
};

const ko_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.00로 경험하기`)
};

const pt_br_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste por R$ 0.00`)
};

const ru_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте за 0,00 $`)
};

const th_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองใช้ในราคา $0.00`)
};

const tr_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,00 TL'ye dene`)
};

const zh_cn_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.00 领取体验`)
};

const zh_tw_btn_zero_fee_trial = /** @type {(inputs: Btn_Zero_Fee_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.00 領取體驗`)
};

/**
* | output |
* | --- |
* | "Try For $0.00" |
*
* @param {Btn_Zero_Fee_TrialInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_zero_fee_trial = /** @type {((inputs?: Btn_Zero_Fee_TrialInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Zero_Fee_TrialInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_zero_fee_trial(inputs)
	if (locale === "ar") return ar_btn_zero_fee_trial(inputs)
	if (locale === "de") return de_btn_zero_fee_trial(inputs)
	if (locale === "es") return es_btn_zero_fee_trial(inputs)
	if (locale === "fr") return fr_btn_zero_fee_trial(inputs)
	if (locale === "it") return it_btn_zero_fee_trial(inputs)
	if (locale === "ja") return ja_btn_zero_fee_trial(inputs)
	if (locale === "ko") return ko_btn_zero_fee_trial(inputs)
	if (locale === "pt_br") return pt_br_btn_zero_fee_trial(inputs)
	if (locale === "ru") return ru_btn_zero_fee_trial(inputs)
	if (locale === "th") return th_btn_zero_fee_trial(inputs)
	if (locale === "tr") return tr_btn_zero_fee_trial(inputs)
	if (locale === "zh_cn") return zh_cn_btn_zero_fee_trial(inputs)
	return zh_tw_btn_zero_fee_trial(inputs)
});